jQuery(document).ready(function($) {
    // Mostrar el buscador si el checkbox está marcado al cargar
    /* if ($('#buscar-checkbox').prop('checked')) {        
        $('#buscar-checkbox').prop('checked',false);
    } */

    // Manejar el cambio del estado del checkbox
    $('#buscar-checkbox').on('change', function() {
        if ($(this).is(':checked')) {
            $('#buscar-checkbox').prop('checked',true);
            $('#buscador-eureka').removeClass('hide');
            $('#buscador-eureka').fadeIn(300).addClass('show');
        } else {
            $('#buscar-checkbox').prop('checked',false);
            $('#buscador-eureka').fadeOut(300).removeClass('show');
        }
    });

    /* $('#buscador__search-form-filters-container').on('reset', function() {
        setTimeout(() => {
            document.getElementById("buscador__toggle-filters").checked = true;
        }, 0); // Se ejecuta justo después del reset
    }); */
    $('#buscador__btn-reset').on('click', function(e) {
        e.preventDefault(); // Evita comportamiento por defecto del botón
        // Restaurar terminos de la barra de búsqueda
        console.log('prevent default');

        const searchInput = document.getElementById("buscador__search-input");
        const searchInputValue = searchInput.value;
        // Restaurar el estado del checkbox de filtros
        const toggleFilters = document.getElementById("buscador__toggle-filters");
        const toggleState = toggleFilters.checked;


        // Restaurar el estado de los filtros
        const filtroFormatoLargo = document.getElementById("post_type--videolargo");
        filtroFormatoLargo.checked = false;

        const filtroFormatoCorto = document.getElementById("post_type--videocorto");
        filtroFormatoCorto.checked = false;

        const filtroFormatoPodcast = document.getElementById("post_type--podcast");
        filtroFormatoPodcast.checked = false;

        const filtroGeneroMujer = document.getElementById("genre-m");
        filtroGeneroMujer.checked = false;

        const filtroGeneroHombre = document.getElementById("genre-h");
        filtroGeneroHombre.checked = false;

        const filtroCategoriaN1 = document.getElementById("select-ambito-n1");
        filtroCategoriaN1.selectedIndex = 0;

        const filtroCategoriaN2 = document.getElementById("select-estudio-n2");
        filtroCategoriaN2.selectedIndex = 0;
        filtroCategoriaN2.setAttribute("hidden", true);
        const filtroCategoriaN3 = document.getElementById("select-termino-n3");
        filtroCategoriaN3.selectedIndex = 0;
        filtroCategoriaN3.setAttribute("hidden", true);

        // Esperamos al siguiente ciclo de ejecución para restaurarlo antes de que el DOM procese los cambios visuales
        /* requestAnimationFrame(() => {
            searchInput.value = searchInputValue;
            toggleFilters.checked = toggleState;
            window.history.pushState({}, "", window.location.pathname);
        }); */
        // Elimina los parámetros de la URL (limpia la búsqueda)
    });
});
